import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute, Route } from '@angular/router';

@Component({
  selector: 'dcc-tabbed-navigation',
  templateUrl: './tabbed-navigation.component.html',
  styleUrls: ['./tabbed-navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabbedNavigationComponent {
  constructor(protected route: ActivatedRoute) {}

  isRouteVisible(r: Route): boolean {
    const toggle = r.data?.['featureToggle'];
    if (!toggle) return true;
    return this.route.snapshot.queryParamMap.get(toggle) === 'true';
  }
}
